import { Choice, ImageUpload, Text, Toggle } from "./fields";

export const ProfileTab = ({ d, set }) => (
  <div className="space-y-4" data-testid="tab-profile">
    <div className="grid sm:grid-cols-2 gap-3">
      <Text k="bot_name" d={d} set={set} label="Bot name" max={40} />
      <Text k="tagline" d={d} set={set} label="Small line under the name" max={80} />
    </div>
    <ImageUpload k="avatar_url" d={d} set={set} label="Profile / human picture" hint="Shown in the chat header. Leave empty to use the brand smile." round={d.avatar_shape !== "square"} />
    <div className="grid sm:grid-cols-2 gap-3">
      <Choice k="avatar_shape" d={d} set={set} label="Picture shape" options={[["round", "Round"], ["rounded", "Rounded square"], ["square", "Square"]]} />
      <Toggle k="show_name_smiles" d={d} set={set} label="Smile symbols around the name" on="🙂 Name 🙂" off="Name only" />
    </div>
  </div>
);
